import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { DEMO_DATASETS } from '@/data/demoDatasets';
import { useStore } from '@/store';

interface LoadDemoModalProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Modal picker listing all available demo datasets by name + description
 * (Stage 10 — standard load mechanism). Selecting a dataset loads it
 * into the store as the active study and closes the modal.
 */
export function LoadDemoModal({ open, onClose }: LoadDemoModalProps) {
  const loadDemoDataset = useStore((s) => s.loadDemoDataset);

  const handleSelect = (build: () => Parameters<typeof loadDemoDataset>[0]) => {
    loadDemoDataset(build());
    onClose();
  };

  return (
    <Modal open={open} title="Load demo dataset" onClose={onClose}>
      <p className="field-hint mt-0">
        Choose a pre-configured dataset to explore the calculator with realistic values.
        Loading a dataset adds it as a new active study — your existing studies are not modified.
      </p>
      <ul className="demo-dataset-list">
        {DEMO_DATASETS.map((entry) => (
          <li key={entry.id} className="demo-dataset-item">
            <div className="demo-dataset-meta">
              <span className="demo-dataset-name">{entry.name}</span>
              <span className="demo-dataset-desc">{entry.description}</span>
            </div>
            <Button variant="secondary" size="sm" onClick={() => handleSelect(entry.build)}>
              Load
            </Button>
          </li>
        ))}
      </ul>
    </Modal>
  );
}
